import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'atom-status-book',
  imports: [CommonModule],
  templateUrl: './status-book.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusBookAtom implements OnInit {
  @Input() isTitle = true;
  @Input() status = '';

  constructor() {}

  ngOnInit(): void {}
}
